module.exports = __webpack_public_path__ + "static/media/default.f02689c5.jpg";